module.exports = __webpack_public_path__ + "static/fonts/text-security-square-compat.a055699.eot";